<template>
  <el-dialog :visible.sync="visible" width="1400px" :close-on-click-modal="false" :show-close="true" @closed="clearData"
    @opened="initMap" custom-class="charge-info-dialog">
    <div class="dialog-header">
      <el-button type="text" icon="el-icon-close" @click="closeDialog" class="close-btn"></el-button>
    </div>
    <div v-loading="loading" class="charge-info-container">
      <!-- 上方：地图和基本信息左右布局 -->
      <el-row :gutter="20">
        <!-- 左侧：地图展示 -->
        <el-col :span="16">
          <el-card shadow="never" class="map-card">
            <div slot="header">
              <span>位置信息</span>
            </div>
            <div id="chargeInfoMap" class="map-container"></div>
          </el-card>
        </el-col>

        <!-- 右侧：基本信息 -->
        <el-col :span="8">
          <el-card shadow="never" class="info-card">
            <div slot="header">
              <span>基本信息</span>
            </div>
            <div class="info-item">
              <div class="label">充电状态：</div>
              <div class="value">
                <el-tag :type="chargeStatusType" size="medium">
                  {{ chargeStatusText }}
                </el-tag>
                <span v-if="realTimeChargeInfo" class="soc-text">
                  （电量：{{ realTimeChargeInfo.totalSoc || 0 }}%）
                </span>
              </div>
            </div>
            <div class="info-item">
              <div class="label">最后订单时间：</div>
              <div class="value">
                <span v-if="lastOrderTime">
                  {{ lastOrderTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}
                </span>
                <span v-else class="no-data">暂无数据</span>
              </div>
            </div>
            <div v-if="realTimeChargeInfo" class="info-item">
              <div class="label">剩余续航里程：</div>
              <div class="value">
                {{ realTimeChargeInfo.rangeMileage || 0 }} KM
              </div>
            </div>
            <div v-if="realTimeChargeInfo && realTimeChargeInfo.latestChargeTime" class="info-item">
              <div class="label">最后充电时间：</div>
              <div class="value">
                {{ realTimeChargeInfo.latestChargeTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}
              </div>
            </div>
            <div v-if="realTimeChargeInfo && realTimeChargeInfo.latestChargeSoc !== null" class="info-item">
              <div class="label">最后充电电量：</div>
              <div class="value">
                {{ realTimeChargeInfo.latestChargeSoc }}%
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 下方：电量状态图表 -->
      <div class="chart-container">
        <Chart ref="chargeChart" :option="chartOption" :height="200" :onLoad="onChartLoad" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getChargeInfoDetail } from "@/api";
import Chart from "@/components/Chart";
import { DateUtil } from "@/util";

const carPng = require("@/assets/image/car_blue.png");
const carRedPng = require("@/assets/image/car_red.png");

export default {
  name: "DriverChargeInfoModal",
  components: {
    Chart
  },
  data() {
    return {
      visible: false,
      loading: false,
      driverId: null,
      chargeInfos: [],
      realTimeChargeInfo: null,
      realTimeState: null,
      location: null,
      chart: null,
      map: null,
      markers: []
    };
  },
  computed: {
    currentLocation() {
      // 直接使用接口返回的 location 字段
      return this.location;
    },
    chargeStatusText() {
      if (!this.realTimeChargeInfo) {
        return "未知";
      }
      const status = this.realTimeChargeInfo.chargeStatus;
      if (status === 1) {
        return "停车充电";
      } else if (status === 3) {
        return "未充电";
      }
      return "未知";
    },
    chargeStatusType() {
      if (!this.realTimeChargeInfo) {
        return "info";
      }
      const status = this.realTimeChargeInfo.chargeStatus;
      if (status === 1) {
        return "success";
      } else if (status === 3) {
        return "warning";
      }
      return "info";
    },
    lastOrderPosition() {
      if (this.realTimeState && this.realTimeState.latestRouteFinishPosition) {
        return this.realTimeState.latestRouteFinishPosition;
      }
      return null;
    },
    lastOrderTime() {
      if (this.realTimeState && this.realTimeState.latestOrderFinishTime) {
        return this.realTimeState.latestOrderFinishTime;
      }
      return null;
    },
    chartOption() {
      // 处理电量数据，按时间排序
      if (!this.chargeInfos || this.chargeInfos.length === 0) {
        return {
          tooltip: {
            trigger: "axis"
          },
          xAxis: {
            type: "category",
            data: []
          },
          yAxis: {
            type: "value",
            name: "电量(%)",
            min: 0,
            max: 100
          },
          series: [
            {
              name: "电量",
              type: "bar",
              data: []
            }
          ]
        };
      }

      // const sortedInfos = [...this.chargeInfos].sort((a, b) => {
      //   const timeA = a.dataDateTime || a.createTime;
      //   const timeB = b.dataDateTime || b.createTime;
      //   return new Date(timeA) - new Date(timeB);
      // });

      const sortedInfos = [...this.chargeInfos];

      const times = sortedInfos.map((item) => {
        // const time = item.dataTime ;
        // return DateUtil.format(new Date(time), "hh:mm");
        return DateUtil.dateStrFormat(item.createTime, "hh:mm");
      });

      const socs = sortedInfos.map((item) => item.totalSoc || 0);

      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: (params) => {
            const param = params[0];
            return `${param.name}<br/>电量: ${param.value}%`;
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: times,
          axisLabel: {
            rotate: 45,
            interval: Math.floor(times.length / 10) || 0
          }
        },
        yAxis: {
          type: "value",
          name: "电量(%)",
          min: 0,
          max: 100,
          axisLabel: {
            formatter: "{value}%"
          }
        },
        series: [
          {
            name: "电量",
            type: "bar",
            data: socs,
            itemStyle: {
              color: (params) => {
                const value = params.value;
                if (value >= 80) {
                  return "#67C23A";
                } else if (value >= 50) {
                  return "#E6A23C";
                } else if (value >= 20) {
                  return "#F56C6C";
                } else {
                  return "#909399";
                }
              }
            }
          }
        ]
      };
    }
  },
  methods: {
    show(driverId) {
      this.driverId = driverId;
      this.visible = true;
      // 如果地图已存在，先初始化
      if (this.map) {
        this.initMap();
      }
      this.loadData();
    },
    async loadData() {
      if (!this.driverId) {
        return;
      }
      this.loading = true;
      try {
        const res = await getChargeInfoDetail(this.driverId);
        const { chargeInfos = [], realTimeChargeInfo, realTimeState, location } = res.data || {};
        this.chargeInfos = chargeInfos;
        this.realTimeChargeInfo = realTimeChargeInfo;
        this.realTimeState = realTimeState;
        this.location = location;

        // 更新地图标记
        this.$nextTick(() => {
          this.updateMapMarkers();
        });

        // 更新图表
        this.$nextTick(() => {
          if (this.chart && this.$refs.chargeChart) {
            this.$refs.chargeChart.setOption(this.chartOption);
          }
        });
      } catch (error) {
        console.error("加载充电信息失败:", error);
      } finally {
        this.loading = false;
      }
    },
    onChartLoad(chart) {
      this.chart = chart;
      // 如果数据已加载，立即设置图表选项
      if (this.chargeInfos && this.chargeInfos.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.chargeChart) {
            this.$refs.chargeChart.setOption(this.chartOption);
          }
        });
      }
    },
    initMap() {
      // 确保地图容器存在
      if (!document.getElementById("chargeInfoMap")) {
        return;
      }
      if (this.map) {
        this.map.clearMap();
        this.markers = [];
      } else {
        this.map = new AMap.Map("chargeInfoMap", {
          resizeEnable: true,
          dragEnable: true,
          zoom: 13
        });
      }
      // 如果数据已加载，立即更新标记
      if (this.location || this.lastOrderPosition) {
        this.$nextTick(() => {
          this.updateMapMarkers();
        });
      }
    },
    updateMapMarkers() {
      if (!this.map) {
        return;
      }
      // 清除现有标记
      this.map.clearMap();
      this.markers = [];

      const positions = [];

      // 添加当前位置标记
      if (this.currentLocation && this.currentLocation.lat && this.currentLocation.lng) {
        const position = [parseFloat(this.currentLocation.lng), parseFloat(this.currentLocation.lat)];
        positions.push(position);
        const currentMarker = new AMap.Marker({
          position,
          draggable: true,
          raiseOnDrag: true,
          label: {
            direction: "top",
            content: "<div class='info'>" + this.realTimeState.driverNo + "</div>"
          },
          icon: new AMap.Icon({
            size: new AMap.Size(40, 40),
            image: carPng,
            imageSize: new AMap.Size(40, 40)
          })
        });
        this.map.add(currentMarker);
        this.markers.push(currentMarker);
      }

      // 添加最后订单位置标记
      if (this.lastOrderPosition && this.lastOrderPosition.lat && this.lastOrderPosition.lng) {
        const position = [parseFloat(this.lastOrderPosition.lng), parseFloat(this.lastOrderPosition.lat)];
        positions.push(position);
        const orderTime = this.lastOrderTime ? DateUtil.dateStrFormat(this.lastOrderTime, "MM-dd hh:mm") : "";

        const iconImg = `/yxmgt/static/image/point/grey_st_1.png`;

        const lastOrderMarker = new AMap.Marker({
          position,
          draggable: true,
          raiseOnDrag: true,
          label: {
            direction: "top",
            content: `<div class='info'>最后订单位置${orderTime ? "<br/>" + orderTime : ""}</div>`
          },
          icon: new AMap.Icon({
            image: iconImg,
            imageSize: new AMap.Size(70, 56)
          }),
          anchor: "bottom-center",
        });
        this.map.add(lastOrderMarker);
        this.markers.push(lastOrderMarker);
      }

      // 添加最后充电位置标记
      if (this.realTimeChargeInfo && this.realTimeChargeInfo.chargePosition &&
        this.realTimeChargeInfo.chargePosition.lat && this.realTimeChargeInfo.chargePosition.lng) {
        const position = [
          parseFloat(this.realTimeChargeInfo.chargePosition.lng),
          parseFloat(this.realTimeChargeInfo.chargePosition.lat)
        ];
        positions.push(position);
        const chargeTime = this.realTimeChargeInfo.latestChargeTime
          ? DateUtil.dateStrFormat(this.realTimeChargeInfo.latestChargeTime, "MM-dd hh:mm")
          : "";
        const chargeSoc = this.realTimeChargeInfo.latestChargeSoc !== null
          ? this.realTimeChargeInfo.latestChargeSoc + "%"
          : "";
        const chargeLabel = `最后充电位置${chargeTime ? "<br/>" + chargeTime : ""}${chargeSoc ? "<br/>电量: " + chargeSoc : ""}`;

        const lastChargeMarker = new AMap.Marker({
          position,
          draggable: false,
          raiseOnDrag: false,
          label: {
            direction: "top",
            content: `<div class='info'>${chargeLabel}</div>`
          },
          icon: new AMap.Icon({
            size: new AMap.Size(40, 40),
            image: carRedPng,
            imageSize: new AMap.Size(40, 40)
          })
        });
        this.map.add(lastChargeMarker);
        this.markers.push(lastChargeMarker);
      }

      // 调整地图视野以包含所有标记
      if (positions.length > 0) {
        this.map.setFitView(this.markers);
      } else if (this.currentLocation && this.currentLocation.lat && this.currentLocation.lng) {
        // 如果只有当前位置，居中显示
        this.map.setCenter([parseFloat(this.currentLocation.lng), parseFloat(this.currentLocation.lat)]);
      }
    },
    closeDialog() {
      this.visible = false;
    },
    clearData() {
      this.driverId = null;
      this.chargeInfos = [];
      this.realTimeChargeInfo = null;
      this.realTimeState = null;
      this.location = null;
      this.loading = false;
      if (this.map) {
        this.map.clearMap();
        this.markers = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.charge-info-container {
  min-height: 400px;
}

.map-card,
.info-card {
  height: 100%;
}

.map-container {
  width: 100%;
  height: 400px;
}

.chart-container {
  padding: 10px 10px;
}

.info {
  font-size: 14px;
  font-weight: bold;
  color: #ff5722;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

.info-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;

  .label {
    width: 120px;
    font-weight: bold;
    color: #606266;
    flex-shrink: 0;
  }

  .value {
    flex: 1;
    color: #303133;

    .soc-text {
      margin-left: 10px;
      color: #909399;
      font-size: 14px;
    }

    .no-data {
      color: #909399;
      font-style: italic;
    }
  }
}

/deep/ .el-card__header {
  font-weight: bold;
  font-size: 16px;
  padding: 15px 20px;
  border-bottom: 1px solid #EBEEF5;
}

/deep/ .el-card__body {
  padding: 20px;
}

/deep/ .charge-info-dialog {
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    overflow: hidden;
    max-height: calc(90vh - 20px);
  }
}

.dialog-header {
  position: relative;
  height: 40px;
  padding: 10px 20px 0;
  text-align: right;

  .close-btn {
    font-size: 20px;
    color: #909399;
    padding: 0;
    width: 30px;
    height: 30px;
    line-height: 30px;

    &:hover {
      color: #303133;
    }
  }
}

.charge-info-container {
  overflow: hidden;
}
</style>
